import { formatLine } from './callFormat';

/** Джерела звернення (enum InquirySource на бекенді) — підписи для форм і налаштувань. */
export const INQUIRY_SOURCE_LABEL = {
  CALL: 'Дзвінок',
  EMAIL: 'Пошта',
  MESSENGER: 'Месенджер',
  PROM: 'prom.ua',
  ZEUS_UA: 'zeus.ua',
  ZEUS_HELI: 'zeus-heli.com.ua',
  FSUA: 'fsua.com.ua',
  OLX: 'olx.ua',
  AUTORIA: 'auto.ria.com',
  OTHER: 'Інше',
};

/** Лінія звернення («номер · назва»): лінія-джерело ручного звернення або лінія першого дзвінка. */
export function inquiryLineLabel(row, { withNumber = true } = {}) {
  if (row?.source !== 'CALL') return '';
  const call = row.calls?.[0];
  const line = row.sourceLine || call?.line;
  const name = line?.name;
  // без номера — лише назва; якщо назви немає (або вона сама є номером з автоімпорту), лишаємо повний підпис
  if (!withNumber && name && /\D/.test(name)) return name;
  return formatLine(line, call?.did);
}
